import styled from "styled-components";

export const IconContainer = styled.div<{selected: boolean}>`
  width: 77px;
  height: 77px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.inputBackground};
  border-radius: 8px;
  
  border: 1px solid;
  border-color: ${props => props.selected ? props.theme.colors.primary : 'transparent'};

  transition:  all 0.5s;

  &:hover {
    cursor: pointer;
  }

  &:active {
    background-color: ${props => props.theme.colors.line};
  }
`;